import { Recorder } from "@/utils/recorder";

export class CallConnectionModel {
  localStream: MediaStream;
  remoteStream: MediaStream;
  peerConnection: RTCPeerConnection;
  audioOutputDevices: MediaDeviceInfo[];
  audioInputDevices: MediaDeviceInfo[];
  sessionId: string;
  audioContext?: AudioContext;
  audioSource?: MediaStreamAudioSourceNode;
  recorder?: Recorder;
  recordingChunks: Blob[];

  constructor(sessionId: string) {
    this.localStream = new MediaStream();
    this.remoteStream = new MediaStream();
    this.peerConnection = new RTCPeerConnection();
    this.audioOutputDevices = [];
    this.audioInputDevices = [];
    this.recordingChunks = [];
    try {
      this.audioContext = new AudioContext();
    } catch (error) {
      console.error("Failed to create AudioContext:", error);
      // Handle the error appropriately
    }
    this.sessionId = sessionId;
  }

  public cleanup(): void {
    this.localStream?.getTracks().forEach((track) => track.stop());
    this.remoteStream?.getTracks().forEach((track) => track.stop());
    this.peerConnection?.close();
    if (this.audioContext?.state !== "closed") {
      this.audioContext?.close();
    }
    this.audioSource?.disconnect();
    this.recorder?.stop();
  }
}
